import { BASE_URL } from './config'

async function fetchWithHandling(url: string, options: RequestInit) {
  const response = await fetch(url, options)
  if (!response.ok) {
    let errorMessage = 'An error occurred'
    try {
      const errorData = await response.json()
      errorMessage = errorData.message || errorMessage
    } catch (e) {
      errorMessage = response.statusText
    }
    throw new Error(errorMessage)
  }
  return response.json()
}

export async function getWsToken(token: string) {
  return fetchWithHandling(`${BASE_URL}/api/v1/ws-token`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export function createDeviceWebSocket(wsToken: string) {
  const wsUrl = BASE_URL.replace(/^https/, 'wss').replace(/^http/, 'ws')
  return new WebSocket(`${wsUrl}/ws/device?token=${wsToken}&role=app`)
}
